"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["for"];
const _hoisted_2 = {
    key: 0,
    class: "block pb-2 font-bold uppercase tracking-wide text-sm"
};
const _hoisted_3 = { class: "relative w-full flex flex-row items-center" };
const _hoisted_4 = {
    key: 0,
    class: "absolute w-10 flex items-center justify-center"
};
const _hoisted_5 = ["id", "type", "name", "placeholder", "autofocus", "required", "value", "disabled", "readonly", "maxlength", "max", "min", "pattern", "autocomplete", "step"];
const _hoisted_6 = {
    key: 1,
    class: "text-red mt-2 text-sm"
};
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShopInput',
    props: {
        type: {
            type: String,
            default: "text",
        },
        name: String,
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        autofocus: Boolean,
        required: Boolean,
        pattern: String,
        showValidity: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
            required: false
        },
        invalidMessage: {
            type: String,
            required: false,
            default: ''
        },
        icon: {
            type: String,
            required: false,
        },
        modelValue: {
            type: [String, Number, () => null],
            default: null
        },
        disableFocusRing: {
            type: Boolean,
            default: false,
        },
        border: {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
        readonly: Boolean,
        maxLength: {
            type: [Number, () => null],
            required: false
        },
        max: {
            type: [Number, String],
            required: false
        },
        min: {
            type: [Number, String],
            required: false
        },
        autocomplete: {
            type: Boolean,
            default: true
        },
        step: {
            type: Number,
            default: 1,
            required: false
        },
        allowedChars: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: () => { var _a; return `shop-input-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    emits: ["update:modelValue", "keyup", "validate"],
    setup(__props, { emit }) {
        const props = __props;
        const emitModelValue = (event) => {
            const target = event.target;
            if (target instanceof HTMLInputElement) {
                let inputValue = target.value;
                if (props.allowedChars) {
                    const allowedCharsRegex = new RegExp(`^${props.allowedChars}+$`);
                    emit('validate', allowedCharsRegex.test(inputValue));
                    if (!allowedCharsRegex.test(inputValue)) {
                        return;
                    }
                }
                emit('update:modelValue', props.type === 'number' ? Number(target.value).valueOf() : target.value);
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                for: __props.id,
                class: "flex flex-col w-full justify-center"
            }, [
                (__props.label)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, (0, vue_2.toDisplayString)(__props.label), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (__props.icon)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, [
                            (0, vue_2.createElementVNode)("i", {
                                class: (0, vue_2.normalizeClass)(["text-lg text-gray-dark", __props.icon])
                            }, null, 2)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("input", {
                        id: __props.id,
                        type: __props.type,
                        name: __props.name,
                        placeholder: __props.placeholder,
                        autofocus: __props.autofocus,
                        required: __props.required,
                        class: (0, vue_2.normalizeClass)(["block py-2 px-2 w-full placeholder-gray-dark text-[15px] outline-none transition-all duration-300 disabled:bg-gray h-12", {
                                'border': __props.border,
                                'border-gray-dark': __props.border,
                                'border-opacity-50': __props.border,
                                'focus:border-blue': __props.border,
                                'pl-10': __props.icon,
                                'focus:ring-4': !__props.disableFocusRing,
                                'focus:ring-blue': !__props.disableFocusRing,
                                'focus:ring-opacity-50': !__props.disableFocusRing,
                                'border-green': __props.valid && __props.showValidity,
                                'border-red': !__props.valid && __props.showValidity
                            }]),
                        value: __props.modelValue,
                        onInput: emitModelValue,
                        onKeyup: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('keyup', $event))),
                        disabled: __props.disabled,
                        readonly: __props.readonly,
                        maxlength: __props.maxLength,
                        max: __props.max,
                        min: __props.min,
                        pattern: __props.pattern,
                        autocomplete: __props.autocomplete ? 'on' : 'off',
                        step: __props.step
                    }, null, 42, _hoisted_5)
                ]),
                (__props.showValidity && __props.invalidMessage !== '' && !__props.valid)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)(__props.invalidMessage), 1))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
